import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
//import moment from "moment";

import {
  sortArrayOfObjects,
  capitalizeFirst,
  fetchFirstLetter,
} from "../utilities/methods";

import DataTable from 'react-data-table-component';

import DeleteModal from "../components/deleteModal";
import { deleteUser } from "../redux/actions/user-action-types";
import moment from "moment";

import './product/product.css';

const customStyles = {
  headCells: {
    style: {
      paddingLeft: '8px', 
      paddingRight: '8px',
      fontSize:'18px',
      fontWeight:'bold'
    },
  },
};

function RegisteredUsers() {
  /** State Variables */
  const [_users, setUsers] = useState([]),
    [orderby, setOrderBy] = useState("createdAt"),
    [sortby, setSortby] = useState("desc"),
    [showDeleteModal, setShowDeleteModal] = useState(false),
    [selectedField, setSelectedField] = useState({}),
    [columns, setColumns] = useState([]),
    [pages, setPage] = useState(0),
    [pageLimit] = useState(2),
    [dataLimit]=useState(10)
  /** Redux Variables */
  const users = useSelector((state) => state.user?.users);

   /*Pagination logic*/
   //const [currentPage, setCurrentPage] = useState(1);

   useEffect(() => {
     if (users.length) {
         setPage(Math.round(users.length / dataLimit))
     }
   },[users]);
   /*End pagination logic */
 

  useEffect(() => {

    let filteredUsers = users.sort(sortArrayOfObjects(orderby, sortby));
    setUsers([...filteredUsers]);
    setColumns([
      {
        name: 'Name',
        cell: row =>{
            return(
              <React.Fragment>
                <span className="circle-style mr-3 bg1">
                  {fetchFirstLetter(row.firstName)}
               </span>
                {`${capitalizeFirst(row.firstName)} ${capitalizeFirst(
                  row.lastName
                )}`}
            </React.Fragment>
          )
        },
        selector: 'firstName',
        sortable: true
     },
     {
         name: 'Joined On',
         cell: row =>{
           return(
              <span>
                 {moment(parseInt(row.createdAt)).format("ll")}
              </span>
           )
         },
         selector: 'createdAt',
         sortable: true,
     },
     {
        name: 'Role',
        cell: row =>{
          return(
             <span>
                {row.role ? capitalizeFirst(row.role) : "User"}
             </span>
          )
        },
        selector: 'role',
        sortable: true,
     },
     {
        name: 'Email',
        selector: 'email',
        sortable: true,
     },
     {  
        name: 'Action',
        cell: row => {return(
          <div className="dropdown">
          <UncontrolledDropdown setActiveFromChild>
            <DropdownToggle tag="a">
              <button
                
                className="btn btn-link  py-0 px-0"
                type="button"
                id="dropdownMenuButton"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <svg
                  width="22"
                  height="6"
                  viewBox="0 0 22 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                  <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                  <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                </svg>
              </button>
            </DropdownToggle>
            <DropdownMenu
              className="dropdown-menu dropdown-menu-right table-action"
              right
            >
              <DropdownItem
                 onClick={(e)=>{toggleDeleteModal(row)}}
              >
                <svg
                  width="17"
                  height="18"
                  viewBox="0 0 17 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 4.20044H2.6H15.4"
                    stroke="black"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z"
                    stroke="black"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.59961 8.19995V13"
                    stroke="black"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9.79883 8.19995V13"
                    stroke="black"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Delete
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </div>
         
        )},
     },
    ])
  }, [users, orderby, sortby]);


  const handleChange = (e) => {
    const { value } = e.target;
    if(value){
      let filteredUsers = _users.filter((user) => {
        return (
          user.firstName.toLowerCase().includes(value.toLowerCase()) ||
          user.lastName.toLowerCase().includes(value.toLowerCase()) ||
          user.email.toLowerCase().includes(value.toLowerCase())  
        );
      });
  
      setUsers(filteredUsers);
    }else {
      let filteredUsers = users.sort(sortArrayOfObjects(orderby, sortby));
      setUsers([...filteredUsers]);
    }
    
  };

  /*const sort = (e, orderby, sortby) => {
    e.preventDefault();
    setOrderBy(orderby);
    setSortby(sortby);
  };

  const sortByLatest = () => {
    setSortby("desc");
    let filteredUsers = _users.sort(sortArrayOfObjects(orderby, sortby));
    setUsers([...filteredUsers]);
  }

  const sortByOldest = () => {
    setSortby("asc");
    let filteredUsers = _users.sort(sortArrayOfObjects(orderby, sortby));
    setUsers([...filteredUsers]);
  }

   function goToNextPage() {
       setCurrentPage((page) => page + 1);
       setPage(_users.length);
    }

    function goToPreviousPage() {
        setCurrentPage((page) => page - 1);
        setPage(_users.length);
    }

    function changePage(event) {
        const pageNumber = Number(event.target.textContent);
        setCurrentPage(pageNumber);
    }

    const getPaginatedData = () => {
      const startIndex = currentPage * dataLimit - dataLimit;
      const endIndex = startIndex + dataLimit;
      return _users.slice(startIndex, endIndex);
    };

    const getPaginationGroup = () => {
      let start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
      return new Array(pageLimit).fill().map((_, idx) => start + idx + 1);
    };*/
   

    const toggleDeleteModal = (field = null) => {
      setSelectedField({
        ...selectedField,
        ...field,
      });
      setShowDeleteModal(!showDeleteModal);
    };

  return (
    <div className="mainContentWrapper">
      <div className="dashContentHeader d-flex justify-content-between align-items-center">
        <h5 className="dashHeading mb-0">Registered Users</h5>
        <div className="new-btn">
          {/* <button className="sub-button">Post New Listing</button> */}
        </div>
      </div>
      <div className="dashboardCardRow registertbl newtbl">
        <div className="input-group mb-4 search-menu">
          <input
            type="text"
            className="form-control"
            placeholder="Search users..."
            onChange={handleChange}
          />
          <div className="input-group-append">
            <span className="input-group-text">
            <svg width="17" height="17" fill="none"><circle cx="7" cy="7" r="6.3" stroke="#FF7E06" stroke-width="1.3"/><path d="M12 12l4 4" stroke="#FF7E06" stroke-width="1.3" stroke-linecap="round"/></svg>
            </span>
          </div>
        </div>
        {/*<div className="listingTableRow">
          <div className="listingTableHeader d-flex justify-content-between align-items-center">
            <div className=" pb-0">
              <label className="showingtxt">
                Showing {_users.length} Users
              </label>
            </div>
            <div className="d-flex justify-content-end align-items-center">
              <div className="d-flex align-items-center shortListedDropdown">
                
                <div className="dropdown">
                  <UncontrolledDropdown direction="left" setActiveFromChild>
                    <DropdownToggle tag="a" className="cursor-pointer">
                    <label className="mb-0 font-normal">Sort by</label>
                      <button
                        className="border-0 btn-link dropdown-toggle card-link"
                        type="button"
                        id="dropdownMenu1"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                      </button>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={()=>{sortByLatest()}}>Latest</DropdownItem>
                      <DropdownItem onClick={()=>{sortByOldest()}}>Oldest</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <table className="table customDashboardTable register-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Joined on</th>
                  <th>Role</th>
                  <th>Email</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {getPaginatedData().map((user, index) => (
                  <tr key={index}>
                    <td className="d-flex align-items-center">
                      <span className="circle-style mr-3 bg1">
                        {fetchFirstLetter(user.firstName)}
                      </span>
                      {`${capitalizeFirst(user.firstName)} ${capitalizeFirst(
                        user.lastName
                      )}`}
                    </td>
                    <td>
                      {moment(parseInt(user.createdAt)).format("DD/MM/YYYY")}
                    </td>
                    <td>{user.role ? capitalizeFirst(user.role) : "User"}</td>
                    <td className="orange-text">{user.email}</td>
                    <td>
                      <div className="dropdown">
                        <UncontrolledDropdown setActiveFromChild>
                          <DropdownToggle tag="a">
                            <button
                              className="btn btn-link dropdown-toggle py-0 px-0"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <svg
                                width="22"
                                height="6"
                                viewBox="0 0 22 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx="3" cy="3" r="3" fill="#C4C4C4" />
                                <circle cx="11" cy="3" r="3" fill="#C4C4C4" />
                                <circle cx="19" cy="3" r="3" fill="#C4C4C4" />
                              </svg>
                            </button>
                          </DropdownToggle>
                          <DropdownMenu
                            className="dropdown-menu dropdown-menu-right table-action"
                            right
                          >
                            <DropdownItem
                               onClick={(e)=>{toggleDeleteModal(user)}}
                            >
                              <svg
                                width="17"
                                height="18"
                                viewBox="0 0 17 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 4.20044H2.6H15.4"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M4.99961 4.2V2.6C4.99961 2.17565 5.16818 1.76869 5.46824 1.46863C5.7683 1.16857 6.17526 1 6.59961 1H9.79961C10.224 1 10.6309 1.16857 10.931 1.46863C11.231 1.76869 11.3996 2.17565 11.3996 2.6V4.2M13.7996 4.2V15.4C13.7996 15.8243 13.631 16.2313 13.331 16.5314C13.0309 16.8314 12.624 17 12.1996 17H4.19961C3.77526 17 3.3683 16.8314 3.06824 16.5314C2.76818 16.2313 2.59961 15.8243 2.59961 15.4V4.2H13.7996Z"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M6.59961 8.19995V13"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M9.79883 8.19995V13"
                                  stroke="black"
                                  stroke-width="1.4"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Delete
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        <div className="pagination">
            <button
            onClick={goToPreviousPage}
            className={`prev border-0 btn-link ${currentPage === 1 ? 'disabled' : ''}`}
            >
            <svg
                    width="26"
                    height="22"
                    viewBox="0 0 26 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 11H2"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11 2L2 11L11 20"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
          </button>
          {getPaginationGroup().map((item, index) => (
              <button
                key={index}
                onClick={changePage}
                className={`paginationItem ${currentPage === item ? 'active' : null}`}
              >
                <span>{item}</span>
              </button>
            ))}
            <button
            onClick={goToNextPage}
            className={`next border-0 btn-link ${currentPage === pages ? 'disabled' : ''}`}
            >
              <svg
                    width="26"
                    height="22"
                    viewBox="0 0 26 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 11H24"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15 2L24 11L15 20"
                      stroke="#C4C4C4"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
           </button>
          </div>
        
          </div>*/}

        {_users && 
            <DataTable
              striped={true}
              highlightOnHover={true}
              pagination={true}
              paginationPerPage={10} 
              columns={columns}
              data={_users}
              customStyles={customStyles}
              paginationIconPrevious={<svg width="32" height="32" fill="none"><path d="M27 16H5M14 7l-9 9 9 9" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>}
              paginationIconNext={<svg width="32" height="32" fill="none"><path d="M5 16h22M18 7l9 9-9 9" stroke="#C4C4C4" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>}
              paginationComponentOptions={{ 
                noRowsPerPage: false,
                selectAllRowsItem:false 
              }}
          />
          }
      </div>
      {showDeleteModal && selectedField && (
        <DeleteModal
          isOpen={showDeleteModal}
          toggle={toggleDeleteModal}
          id={selectedField.id}
          method={deleteUser}
          content={`Are you sure you want to delete '${selectedField.firstName}' user?`}
        />
      )}
    </div>
  );
}

export default RegisteredUsers;
